import React from 'react';

const NationalPricesConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SALON', 'ROLE_SALON_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/national/prices',
      exact: true,
      component: React.lazy(() => import('./national_prices_list'))
    }
  ]
};

export default NationalPricesConfig;
